import { Modal as MModal } from '@mantine/core';
import React from 'react';
import './Modal.scss';

type ModalProps = {
  opened: boolean;
  onClose: (value: boolean) => void;
  children: React.ReactNode;
  title: React.ReactNode | string;
  trapFocus?: boolean;
  minHeight?: string;
  className?: string;
  closeOnClickOutside?: boolean;
};

export const Modal = ({
  opened,
  onClose,
  children,
  title,
  trapFocus,
  className,
  minHeight,
  closeOnClickOutside,
  ...otherProps
}: ModalProps) => (
  <MModal
    opened={opened}
    radius="lg"
    onClose={() => {
      onClose(false);
    }}
    size="md"
    centered
    className={`custom-modal ${className}`}
    withCloseButton={false}
    transitionProps={{
      transition: 'slide-up',
      duration: 300,
      timingFunction: 'ease',
    }}
    title={title}
    trapFocus={trapFocus}
    closeOnClickOutside={closeOnClickOutside}
    closeOnEscape={closeOnClickOutside}
    padding="lg"
    overlayProps={{
      color: '#000000',
      opacity: 0.5,
    }}
    styles={{
      content: {
        overflowY: 'hidden',
        maxHeight: '70vh',
        minHeight: minHeight ?? 0,
      },
      header: {
        marginBottom: 0,
        paddingBottom: '1rem',
      },
      title: {
        width: '100%',
        marginRight: '5px',
      },
      body: {
        maxHeight: '56vh',
        height: '100%',
        overflowY: 'auto',
      },
    }}
    {...otherProps}
  >
    {children}
  </MModal>
);
